import React from 'react';
import _debounce from 'lodash/debounce';
import { Formik, Form } from 'formik';
import { Input } from 'reactstrap';
import SvgRender from 'components/helpers/SvgRender';
import search from 'assets/svg/Search.svg';

const TableTopSearch = props => {
  const handleSearch = props.onSearch ? _debounce(props.onSearch, 500) : null;

  return (
    <div className="table-mm--search">
      <Formik
        initialValues={{ search: '' }}
        onSubmit={(values, actions) => {}}
        render={({ values, setFieldValue }) => (
          <Form className="form-group--search d-flex align-items-center mb-1">
            <SvgRender className="mt-1 ml-2" path={search} />
            <Input
              name="search"
              type="text"
              placeholder={props.searchPlaceholder ? props.searchPlaceholder : 'Search..'}
              value={values.search}
              className=""
              onChange={e => {
                setFieldValue('search', e.target.value);
                handleSearch(e.target.value);
              }}
            />
          </Form>
        )}
      />
    </div>
  );
};

export default TableTopSearch;



// WEBPACK FOOTER //
// ./src/components/table/TableTopSearch.js